export const taskKeys = {
  mine: ['tasks', 'mine'] as const,
};
